import { createAction, props } from '@ngrx/store';
import { ISJMap } from '../../interfaces/explorer/interfaces/ISJMap';
import { ISJMapDrawing } from '../../interfaces/explorer/interfaces/ISJMapDrawing';
import { ISJMapGroup } from '../../interfaces/explorer/interfaces/ISJMapGroup';
import { AddLayerObject, LayerSpecification } from 'maplibre-gl';
import { ISJMapSource } from '../../interfaces/explorer/interfaces/ISJMapSource';
import { ISJMapLayerItem } from '../../interfaces/explorer/interfaces/ISJMapLayerItem';

export const loadSavedMap = createAction(
    '[Explorer] Load saved map',
    props<{ url: string }>()
);

export const loadSavedMapSuccess = createAction(
    '[Explorer] Load saved map success',
    props<{ savedMap: ISJMap }>()
);

export const loadSavedMapError = createAction(
    '[Explorer] Load saved map error',
    props<{ error: any }>()
);

export const loadSources = createAction(
    '[Explorer] Load sources',
    props<{ sources: ISJMapSource }>()
)

export const loadSourcesSuccess = createAction(
    '[Explorer] Load sources',
    props<{ sources: ISJMapSource }>()
)

export const loadLayers = createAction(
    '[Explorer] Load layers',
    props<{ layers: Array<LayerSpecification> }>()
)

export const loadLayersSuccess = createAction(
    '[Explorer] Load layers',
    props<{ layers: Array<LayerSpecification> }>()
)

export const changeIsToUpdate = createAction(
    '[Explorer] Is to update',
    props<{ isToUpdate: boolean }>()
)

export const addLayerItem = createAction(
    '[Explorer] Add Layer Item on SJMap',
    props<{ layerItem: ISJMapLayerItem }>()
)

export const addGroups = createAction(
    '[Explorer] Add Group',
    props<{ groups: ISJMapGroup[] }>()
)

export const addLayerToGroup = createAction(
    '[Explorer] Add layer to Group',
    props<{ layerItem: ISJMapLayerItem }>()
)
export const addSourceToStore = createAction(
    '[Explorer] Add Source to Store',
    props<{ sourceId: string; source: ISJMapSource }>()
);

/*
export const addLayer = createAction(
    '[Explorer] Add Layer',
    props<{ layer: ISJMapLayer }>()
);

export const updateLayer = createAction(
    '[Explorer] Update Layer',
    props<{ layer: AddLayerObject }>()
);

export const removeLayer = createAction(
    '[Explorer] Remove Layer',
    props<{ layer: AddLayerObject }>()
);

export const addSource = createAction(
    '[Explorer] Add Source',
    props<{ layer: ISJMapLayer }>()
);

export const updateSource = createAction(
    '[Explorer] Update Layer',
    props<{ layer: AddLayerObject }>()
);

export const removeSource = createAction(
    '[Explorer] Remove Layer',
    props<{ layer: AddLayerObject }>()
);
*/
